<script setup lang="ts">
onMounted(() => {
  // アプリからシェアボタンを押されたことを受信するための処理を記述
  window.addEventListener('message', (ev) => onRequestAppAction(ev))
})

/* eslint @typescript-eslint/no-explicit-any: 0 */
const onRequestAppAction = (event: MessageEvent<any>) => {
  useNuxtApp().$onRequestAppAction(event, useShareContents().value)
}
</script>
<template>
  <div>
    <NuxtPage />
  </div>
</template>
